<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Kapellenglöcklein auf Hohenhaus</h3>
<p class="vers">Die Glocke klingt, still rauscht die Eiche;<br class="calibre2"/>
wer hat das kleine Haus erstiegen,<br class="calibre2"/>
vor dem lebend'ge Zauberreiche<br class="calibre2"/>
in sanfter Pracht entfaltet liegen?</p>
<p class="vers">Wem quillt die volle Seele über,<br class="calibre2"/>
daß er das helle Glöcklein läutet?<br class="calibre2"/>
Denn klingt ihr Ton zu uns herüber,<br class="calibre2"/>
so weiß man, daß es Glück bedeutet.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0017.vue?63ebd76e